import type { ReactNode } from 'react'

import { cn } from '@/lib/ui/style-helpers'

export type DrawerLayoutHeaderProps = {
  title: ReactNode
  subtitle?: ReactNode
  badge?: ReactNode
  actions?: ReactNode
  className?: string
  titleClassName?: string
}

export const DrawerLayoutHeader = ({
  title,
  subtitle,
  badge,
  actions,
  titleClassName,
  className,
}: DrawerLayoutHeaderProps) => {
  const hasTopRow = !!badge || !!actions

  return (
    <header className={className}>
      {hasTopRow ? (
        <div className='flex items-center justify-between'>
          {badge ?? <div />}
          {actions ? <div className='flex items-center gap-2 print:hidden'>{actions}</div> : null}
        </div>
      ) : null}
      <div className={cn('text-main-foreground-primary', hasTopRow && 'mt-4')}>
        <h2 className={cn('text-heading-medium', titleClassName)}>{title}</h2>
        {subtitle ? <div className='mt-1.5'>{subtitle}</div> : null}
      </div>
    </header>
  )
}
